import { APIService } from "../apiService";
import { AuthenticationService } from "../authenticationService";
import { ActiveAntsPurchaseOrder, PaginatedActiveAntsPurchaseOrders } from "src/types";
import { GetActiveAntsPurchaseOrdersQueryParams } from "src/types/api";

class ActiveAntsPurchaseOrderAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/active-ants-purchase-orders");
  }

  async getActiveAntsPurchaseOrders(
    queryParams: GetActiveAntsPurchaseOrdersQueryParams
  ): Promise<PaginatedActiveAntsPurchaseOrders> {
    return await this.jwtRequest("GET", undefined, undefined, queryParams);
  }

  async getActiveAntsPurchaseOrderById(activeAntsPurchaseOrderId: string): Promise<ActiveAntsPurchaseOrder> {
    const pathParam = encodeURIComponent(activeAntsPurchaseOrderId);
    const path = `/${pathParam}`;
    return await this.jwtRequest("GET", path);
  }

  async getActiveAntsPurchaseOrderPDFUrl(
    activeAntsPurchaseOrderId: string
  ): Promise<{ url: string; fileName: string }> {
    const pathParam = encodeURIComponent(activeAntsPurchaseOrderId);
    const path = `/${pathParam}/pdf-url`;
    return await this.jwtRequest("GET", path);
  }

  async resolveAAError(
    activeAntsPurchaseOrderId: string,
    requestBody: {
      products: { productId: string; skuName?: string; barcode?: string; variantId?: string }[];
    }
  ): Promise<ActiveAntsPurchaseOrder> {
    const pathParam = encodeURIComponent(activeAntsPurchaseOrderId);
    const path = `/${pathParam}/resolve-aa-error`;
    return await this.jwtRequest("POST", path, requestBody);
  }
}

export { ActiveAntsPurchaseOrderAPIService };
